import icon from '@material-ui/icons/Person'

const queryParams = { icon, options: { label: 'Query params' } }

export default queryParams
